import { isValidValue } from "utils";
import { setCampusData } from "./campusMapper";

const setFloor = (arr) => {
  if (!isValidValue(arr) || !arr.length) {
    return [];
  }
  let obj = {};
  arr.forEach((element) => {
    const id = element.ID ?? element.id;
    obj[id] = {
      id,
      label: element.label,
      name: element.name,
      level: element.level,
      height: element.height,
      is_roof: element.is_roof,
    };
  });
  return obj;
};

export const setBuildingData = (el = {}) => {
  return {
    createdAt: el.CreatedAt || null,
    updatedAt: el.UpdatedAt || null,
    deletedAt: el.DeletedAt || null,
    id: el.ID || null,
    district_id: el.district_id || null,
    campus: setCampusData(el.Campus || {}),
    campus_id: el.campus_id || null,
    area_sq_ft: el.area_sq_ft || 0,
    num_students: el.num_students || 0,
    num_staff: el.num_staff || 0,
    num_drones: el.num_drones || 0,
    name: el.name || null,
    address: el.address || null,
    floors: setFloor(el?.floors ?? []),
    city: el.city || null,
    state: el.state || null,
    zip_code: el.zip_code || null,
    latitude: el.latitude || null,
    longitude: el.longitude || null,
    capacity: el.capacity || 0,
    created_by_id: el.created_by_id || null,
  };
};
